import { render, staticRenderFns } from "./BasisForm.vue?vue&type=template&id=7c87d5d8&scoped=true"
import script from "./BasisForm.vue?vue&type=script&lang=js"
export * from "./BasisForm.vue?vue&type=script&lang=js"
import style0 from "./BasisForm.vue?vue&type=style&index=0&id=7c87d5d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87d5d8",
  null
  
)

export default component.exports